__turbopack_context__.v({
  "viewport": "drag-scroll-area-module__Ewnsgq__viewport",
});
